import jQuery from 'jquery';
import React from 'react';
import classNames from 'classnames';

export default class FavoriteButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			active: props.active === 'true'
		};
	}

	componentDidMount() {
		jQuery(this.props.mountPoint).click((event) => this.toggle(event));
	}

	render() {
		return (
			<i title={String(this.state.active ? this.props.titleRemove : this.props.titleAdd)} className={classNames({
				fa: true,
				'default-hidden': true,
				'loading fa-circle-o-notch fa-spin': this.state.active === null,
				'fa-heart-o': this.state.active === false,
				'active fa-heart': this.state.active === true
			})}/>
		)
	}

	toggle(event) {
		event.stopPropagation();
		event.preventDefault();

		if(this.state.active === null) {
			return;
		}

		let active = this.state.active;
		this.setState({active:  null});

		jQuery.ajax({
			url: active ? this.props.endpointRemove : this.props.endpointAdd,
			dataType: 'json',
			success: (response) => {
				active = !active;
				document.dispatchEvent(new Event('shop/watchlist/updated'));
			},
			complete: () => this.setState({active: active})
		});
	}
}
